// eslint-disable-next-line import/no-unresolved
import { apiUrl } from '../../../utils/api';
import { apiBasePath } from '../../BasicUrl';


const FoodVariant = apiBasePath.injectEndpoints({
    endpoints: (build) => ({
        getvariantsApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.variants}`,
                method: "POST",
                body: data,

            }),
        }),
        getvariantsDeleteApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.variantsDelete}`,
                method: "DELETE",
                body: data,
            })
        }),






    }),
    overrideExisting: false,
});
// export const { useGetSallersApiQuery, useUpdateSallerMutation, useUpdatePhotoMutation, useUpdateLogoMutation, useUpdateTimeMutation, useGetCityQuery, useActivateDeactivateUserApiMutation, useApprovelDeactivateUserApiMutation } = extendedApi;
export const { useGetvariantsApiMutation, useGetvariantsDeleteApiMutation, } = FoodVariant;
